import { t } from '@/translations';
import type SelectOptionInterface from '@/domains/common/typescript/SelectOptionInterface';

const arrayToSelectOption = (array: (string | number)[]): SelectOptionInterface<string>[] =>
    array.map((item) => ({ value: `${item}`, label: t(`${item}`) }));

export default arrayToSelectOption;
